import React, { PropTypes } from 'react';
import StyleButton from './StyleButton.js.jsx';

const BLOCK_TYPES = [
  {label: 'P', style: 'unstyled'},
  {label: 'H1', style: 'header-one'},
  {label: 'H2', style: 'header-two'},
  {label: 'H3', style: 'header-three'},
  {label: 'H4', style: 'header-four'},
  {label: 'H5', style: 'header-five'},
  {label: 'H6', style: 'header-six'},
  {label: <i key={'blockquote'} className="fa fa-quote-left"/>, style: 'blockquote'},
  {label: <i key={'link'} className="fa fa-link"/>, style: 'link'},
  {label: <i key={'unlink'} className="fa fa-link unlink"/>, style: 'unlink'},
  {label: <i key={'UL'} className="fa fa-list-ul"/>, style: 'unordered-list-item'},
  {label: <i key={'OL'} className="fa fa-list-ol"/>, style: 'ordered-list-item'},
];

const BlockStyleControls = (props) => {
  const {editorState} = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type, i) =>
        <StyleButton
          key={i}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          promptForLink={props.promptForLink}
          removeLink={props.removeLink}
        />
      )}
    </div>
  );
};

export default BlockStyleControls;



// WEBPACK FOOTER //
// global/components/forms/editorComponents/FullBlockStyleControls.js.jsx